import { Option } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";

import {
  CrossDockStatus,
  ShipmentStatus,
  ShipmentTrackingStatus,
  ShipmentType,
} from "../../../../util/enums";

const getShipmentOptions = () => {
  const { t: translate } = useTranslation();

  const typeOptions: Option[] = [
    { value: ShipmentType.SEA, label: translate("sea") },
    { value: ShipmentType.AIR, label: translate("air") },
    { value: ShipmentType.ROAD, label: translate("road") },
  ];

  const statusOptions: Option[] = [
    {
      value: ShipmentStatus.PLANNED,
      label: translate("planned"),
    },
    {
      value: ShipmentStatus.BOOKED,
      label: translate("booked"),
    },
    {
      value: ShipmentStatus.STAGED,
      label: translate("staged"),
    },
    {
      value: ShipmentStatus.LOADED,
      label: translate("loaded"),
    },
    {
      value: ShipmentStatus.IN_TRANSIT,
      label: translate("inTransit"),
    },
    {
      value: ShipmentStatus.DELIVERED,
      label: translate("delivered"),
    },
    {
      value: ShipmentStatus.CANCELLED,
      label: translate("cancelled"),
    },
    {
      value: ShipmentStatus.SHIPPED,
      label: translate("shipped"),
    },
    {
      value: ShipmentTrackingStatus.COLLECTED_FROM_SHIPPER,
      label: translate("collectedFromShipper"),
    },
    {
      value: ShipmentTrackingStatus.NOT_ARRIVED_AT_PORT_OF_LOAD,
      label: translate("notArrivedAtPortOfLoad"),
    },
    {
      value: ShipmentTrackingStatus.WAITING_AT_PORT_OF_LOAD,
      label: translate("waitingAtPortOfLoad"),
    },
    {
      value: ShipmentTrackingStatus.SHIPPED_ON_BOARD,
      label: translate("shippedOnBoard"),
    },
    {
      value: ShipmentTrackingStatus.UNDERWAY,
      label: translate("underway"),
    },
    {
      value: ShipmentTrackingStatus.UNDERWAY_TO_A_TRANSHIPMENT_PORT,
      label: translate("underwayToATranshipmentPort"),
    },
    {
      value: ShipmentTrackingStatus.ARRIVAL_AT_TRANSHIPMENT_PORT,
      label: translate("arrivalAtTranshipmentPort"),
    },
    {
      value: ShipmentTrackingStatus.WAITING_AT_TRANSHIPMENT_PORT,
      label: translate("waitingAtTranshipmentPort"),
    },
    {
      value: ShipmentTrackingStatus.LEFT_THE_DESTINATION_PORT,
      label: translate("leftTheDestinationPort"),
    },
    {
      value: ShipmentTrackingStatus.SHIPMENT_COMPLETED,
      label: translate("shipmentCompleted"),
    },
    {
      value: ShipmentTrackingStatus.WAITING_FOR_UPDATE,
      label: translate("waitingForUpdate"),
    },
    {
      value: ShipmentTrackingStatus.TRACKING_NOT_AVAILABLE,
      label: translate("trackingNotAvailable"),
    },
  ].sort(({ label: a }, { label: b }) => a.localeCompare(b));

  const containerTypeOptions: Option[] = [
    { value: "20_dry_standard", label: `20" ${translate("dryStandard")}` },
    { value: "40_dry_standard", label: `40" ${translate("dryStandard")}` },
    { value: "40_dry_high", label: `40" ${translate("dryHigh")}` },
    { value: "45_dry_high", label: `45" ${translate("dryHigh")}` },
    { value: "20_tank", label: `20" ${translate("tank")}` },
    { value: "40_tank", label: `40" ${translate("tank")}` },
    { value: "20_open_top", label: `20" ${translate("openTop")}` },
    { value: "40_open_top", label: `40" ${translate("openTop")}` },
    { value: "40_open_top_high", label: `40" ${translate("openTopHigh")}` },
    { value: "40_flat_standard", label: `40" ${translate("flatStandard")}` },
    { value: "40_flat_high", label: `40" ${translate("flatHigh")}` },
    { value: "20_flat", label: `20" ${translate("flat")}` },
    { value: "20_reefer_standard", label: `20" ${translate("reeferStandard")}` },
    { value: "40_reefer_high", label: `40" ${translate("reeferHigh")}` },
  ];

  const crossDcokStatusOption: Option[] = [
    { value: CrossDockStatus.RECEIVED_EXPECTED, label: translate("receivedExpected") },
    { value: CrossDockStatus.RECEIVED_UNEXPECTED, label: translate("receivedUnexpected") },
    { value: CrossDockStatus.NOT_RECEIVED, label: translate("notReceivedExpected") },
  ];

  return {
    typeOptions,
    statusOptions,
    containerTypeOptions,
    crossDcokStatusOption,
  };
};

export default getShipmentOptions;
